import React from 'react'

import { useLazyQuery } from '@apollo/client'
import { APIStatus } from '@flowwai-frontend/shared/api-common'
import {
   convertToErrorType,
   getAPIStatusFromNetworkStatus
} from '@flowwai-frontend/bps-officer-web/common/data-access'

import {
   GetContactTemplateBasicDetailsDocument as QueryDocument,
   GetContactTemplateBasicDetailsQuery as Query,
   GetContactTemplateBasicDetailsQueryVariables as QueryVariables
} from './query.generatedTypes'
import useAPIResponseHandler from './responseHandler'

interface ReturnType {
   triggerAPI: () => void
   apiStatus: APIStatus
   apiError: Error | null
}

const useGetContactTemplateBasicDetails = (): ReturnType => {
   const [getContactTemplate, { data, error, networkStatus }] = useLazyQuery<
      Query,
      QueryVariables
   >(QueryDocument, { fetchPolicy: 'cache-first' })

   const handleAPIResponse = useAPIResponseHandler()

   const triggerAPI = (): void => {
      getContactTemplate({
         variables: {},
         onCompleted: (data: Query) => handleAPIResponse(data)
      })
   }

   const apiStatus = getAPIStatusFromNetworkStatus(networkStatus, data)
   const apiError = convertToErrorType(error)

   return { triggerAPI, apiStatus, apiError }
}

export default useGetContactTemplateBasicDetails
